var _defineProperty = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/defineProperty.js").default;
var _form;
module.exports = {
  messages: {
    CN: {
      header: {
        preview: '预览草稿',
        save: '保存草稿',
        publish: '发布',
        surepublish: '确认要发布吗？'
      },
      left: {
        publicComponent: '公共组件',
        pcComponent: 'pc端专用组件',
        pcmenubar: '菜单栏',
        pcfooter: '页脚',
        navbar: '导航栏',
        notice: '公告栏',
        swiper: '轮播图',
        banner: '广告图',
        goodslist: '商品列表',
        spacing: '模块间距',
        mobileComponent: '移动端专用组件',
        index: '锚点组件',
        pcAndMobile: 'PC | 移动',
        news: '新着情报'
      },
      right: {
        floor: '楼层',
        floorManager: '楼层管理',
        clarAll: '清除所有组件',
        empty: '没有组件，这里空空如也~'
      },
      stateDesign: {
        copySuccess: '复制组件成功',
        copyError: '复制组件失败',
        deleteAsk: '确认删除该组件？',
        deleteSuccess: '删除组件成功',
        publishSuccess: '发布成功',
        publishError: '发布失败',
        saveSuccess: '保存成功',
        saveError: '保存失败',
        addGoods: '请先添加商品列表组件',
        onlyIndex: '只能有一个锚点索引组件'
      },
      com: {
        recommendProductType: '推荐商品',
        selProductType: '选择商品',
        uploadPic: '上传图片',
        uploadLimit: '上传图片大小不能超过 {num} MB',
        selectGoodsData: '选择商品数据',
        look: '查看',
        alreadySelected: '已选择数量: {num}个',
        askDelete: '是否删除？',
        ok: '确定',
        cancel: '取消',
        addPic: '新增图片',
        editPic: '编辑图片',
        deletePic: '删除图片',
        trackName: 'Google Analytics Tracking Name',
        link: '链接',
        picLink: '图片链接',
        placeInput: '请输入或者选择',
        mobile: '移动',
        unKnownCom: '未知组件',
        noDragHere: '不允许拖到这个位置',
        emptyCom: '哎哟，您还没有放置组件哦~',
        alreadyGoodsData: '已选商品数据',
        add: '添加',
        dragSort: '拖动可以进行排序',
        sellPrice: '售价',
        taxIncluded: '(含税)',
        productNo: '商品编号',
        delete: '删除',
        top: '置顶',
        bottom: '置底',
        productName: '商品名称',
        operation: '操作',
        placeInputGoodsName: '请输入商品名称或者商品编号',
        placeSearchAdd: '请搜索商品后添加',
        alreadyInGoodsList: '已经在商品列表中了',
        addError: '添加失败',
        addSuccess: '添加成功, 请记得"保存草稿"',
        topSuccess: '置顶完成, 请记得"保存草稿"',
        bottomSuccess: '置底完成, 请记得"保存草稿"',
        put: '上架',
        out: '下架',
        sortSuccess: '排序成功, 请记得"保存草稿"',
        stockNumTitle: '库存数量'
      },
      form: (_form = {
        setting: '组件设置',
        location: '显示端',
        systemRecommendNum: '推荐数量',
        systemRecommendPlaceHolder: '请输入推荐数量',
        placeSelectLocation: '请选择客户端',
        contentSetting: '内容设置',
        pcNum: 'PC端每行显示数量',
        oneLineNum: '每行显示数量',
        pcSpacing: 'PC端图片间距',
        ImageSpacing: '图片左右间距',
        ImageVerticalSpacing: '图片上下间距',
        pcDynamic: 'PC端鼠标移入动效',
        Dynamic: '鼠标移入动效',
        open: '开',
        close: '关',
        pcBannerHeight: 'PC端广告图高度',
        BannerHeight: '广告图高度',
        mNum: '移动端每行显示数量',
        mSpacing: '移动端图片间距',
        mBannerHeight: '移动端广告图高度',
        BannerWidth: '广告图宽度',
        mobile: '移动端',
        pc: 'pc端',
        bgColor: '背景颜色',
        mobileBgColor: '移动端背景颜色',
        pcBgColor: 'PC端背景颜色',
        goodsTitle: '商品列表标题',
        titleColor: '标题颜色',
        textSize: '文本大小',
        goods: '商品',
        banner: '广告图',
        deleteSuccess: '删除成功, 请记得"保存草稿"',
        deleteError: '删除失败',
        indexTip: '锚点名称会在预览时动态根据商品列表生成',
        sticky: '吸顶',
        is: '是',
        no: '否',
        textColor: '文本颜色',
        textSelectColor: '文本选择颜色',
        status: '状态',
        visible: '显示',
        hidden: '隐藏',
        textOrIconColor: '文本/图标颜色',
        textOrIconHoverColor: '文本/图标鼠标滑过颜色',
        stickyShow: '吸顶显示',
        onlyPc: '仅PC端有效',
        elementSet: '元素设置',
        logoWidth: 'LOGO宽度',
        langButton: '多语言按钮',
        searchButton: '搜索按钮',
        accountButton: '个人账户按钮',
        cartButton: '购物车按钮',
        paddingTop: 'PC端上边距',
        paddingBottom: 'PC端下边距',
        newTip: '内容将自动调用【新着情报】的数据',
        showPublicDate: '显示发布日期',
        newTitle: '新着情报标题',
        newList: '新着情报内容',
        textOrIconHoverColor2: '文本鼠标滑过颜色',
        showBranches: '显示条数',
        moreVisible: '是否显示更多',
        noticeLink: '公告链接',
        mainTitle: '主标题',
        subTitle: '副标题',
        mainTitle_placeholder: '请输入主标题',
        mainTitle_placeholder2: '请输入【公告栏】中的主标题'
      }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_form, "moreVisible", '是否显示更多'), "moreText", '按钮标题'), "moreLink", '链接地址'), "pcBg", 'PC端背景颜色'), "mobileBg", '移动端背景颜色'), "pcShowNum", 'PC端显示条数'), "mobileShowNum", '移动端显示条数'), "content", '内容'), "logoInfo", 'LOGO信息'), "siteLogo", '网站logo'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_form, "customLink", '自定义链接'), "placeSelectContent", '请选择内容类型'), "copyrightContent", '著作权内容'), "dividingLineColor", '分割线颜色'), "copyright", '网站著作权'), "text", '文本'), "shareMedia", '社交媒体'), "mediaIconSize", '社交媒体图标大小'), "dividingColor", '下划线颜色'), "addCustomLink", '新增自定义链接'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_form, "deleteContent", '删除内容'), "menuCategor", '商品分类'), "toggle", '开关'), "showTitle", '显示标题'), "menulist", '菜单列表'), "addMenu", '新增菜单'), "menuSpacing", '菜单间距'), "menuItem", '菜单项'), "customMenu", '自定义菜单'), "pcSpacingHeight", 'PC端间距高度'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_form, "mSpacingHeight", '移动端间距高度'), "autoPlay", '自动播放'), "interval", '自动播放间隔'), "pcSwiperHeight", 'PC轮播图高度'), "mSwiperHeight", '移动端轮播图高度'), "mHorizontailPadding", '移动端页面左右边距'), "pcHorizontailPadding", 'PC端页面左右边距'), "icon", '图标'), "iconSize", '图标大小'), "gzhIcon", '公众号图片'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_form, "link", '链接'), "vertical", '纵向滑动'), "pdfUpload", '上传PDF'), "pdfUploadSuccessTip", '上传文件成功'), "pdfUploadFailTip", '上传文件失败，请重新上传文件'), "titlePaddingTop", '标题上边距'), "titlePadingBottom", '标题下边距'), "PCMedia", 'PC端'), "mediaIconRight", '社交媒体图标右间距'), "mediaIconBottom", '社交媒体图标下间距'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_form, "mediaIconType", '图标类型'), "image", '图片'), "marginSpace", '左右边距'), "info", '信息'), "subject", '专题'), "subjectTitle", '专题名称'), "addProduct", '添加商品'), "defualtSort", '默认排序'), "onlineSort", '上架时间排序'), "stockSort", '首次入库时间排序'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_form, "linkSet", '链接设置'), "productSearch", '商品搜索结果'), "couponList", '优惠券列表'), "page", '页面'), "place", '请选择'), "channel", '推广平台'), "category", '商品分类'), "brand", '品牌'), "transort", '运输方式'), "sort", '排序'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_form, "orderType", '排序类型'), "orderWay", '排序方式'), "placeOfOrigin", '原产地'), "placeInput", '请输入'), "pageCode", '页码'), "sale", '销量'), "price", '价格'), "commont", '评价'), "newProduct", '新品'), "sort_up", '升序'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_form, "sort_down", '降序'), "bundleCheck", '使用同捆'), "keyword", '关键字'), "exactMatch", '精确匹配'), "dimMatch", '模糊匹配'), "matchtype", '匹配方式'), "activeDetail", '活动详情'), "activity", '活动'), "categoryTitle", "标题（仅移动端）"))
    },
    HK: {
      header: {
        preview: '預覽',
        save: '保存並繼續',
        publish: '發布'
      }
    },
    US: {
      header: {
        preview: 'Preview',
        save: 'Save and continue',
        publish: 'Publishing'
      }
    },
    JP: {
      header: {
        preview: 'ドラフトをプレビュー',
        save: 'ドラフトを保存',
        publish: '公開',
        surepublish: '公開してもよろしいですか？'
      },
      left: {
        publicComponent: '共通コンポーネント',
        pcComponent: 'PCサイト専用コンポーネント',
        pcmenubar: 'メニューバー',
        pcfooter: 'フッター',
        navbar: 'ナビゲーションバー',
        notice: 'アナウンスメントバー',
        swiper: 'スライダー',
        banner: '広告画像',
        goodslist: '商品リスト',
        spacing: 'モジュール間のスペース',
        mobileComponent: 'モバイル端末専用コンポーネント',
        index: 'アンカーコンポーネント',
        pcAndMobile: 'PC | 移動',
        news: '新着情報'
      },
      right: {
        floor: 'フロア',
        floorManager: 'フロア管理',
        clarAll: '全てのコンポーネントをクリア',
        empty: 'コンポーネントがありません~'
      },
      stateDesign: {
        copySuccess: 'コンポーネントのコピーに成功しました',
        copyError: 'コンポーネントのコピーに失敗しました',
        deleteAsk: 'このコンポーネントを削除してもよろしいですか？',
        deleteSuccess: 'コンポーネントの削除に成功しました',
        publishSuccess: '公開しました',
        publishError: '发布失敗',
        saveSuccess: '保存成功',
        saveError: '保存失敗',
        addGoods: '商品リストコンポーネントを先に追加してください',
        onlyIndex: 'アンカーインデックスコンポーネントは1つだけ使用できます'
      },
      com: {
        recommendProductType: 'おすすめ商品',
        selProductType: '商品を選択',
        uploadPic: '画像をアップロード',
        uploadLimit: 'アップロードする画像のサイズは{num}MBを超えてはいけません',
        selectGoodsData: '選択した商品データ',
        look: 'チェック',
        alreadySelected: '選択された数量: {num}個',
        askDelete: '削除しますか？',
        ok: '確定',
        cancel: 'キャンセル',
        addPic: '新しい画像を追加',
        editPic: '画像を編集',
        deletePic: '画像を削除',
        trackName: 'Google Analytics Tracking Name',
        link: 'リンク',
        picLink: '画像リンク',
        placeInput: '入力／選択してください',
        mobile: '移動',
        unKnownCom: '未知のコンポーネント',
        noDragHere: 'この位置にドラッグすることができません',
        emptyCom: 'コンポーネントが配置されていません',
        alreadyGoodsData: '選択された商品データ',
        add: '追加',
        dragSort: 'ドラッグして順番を変更できます',
        sellPrice: '販売価格',
        taxIncluded: '（税込）',
        productNo: '商品コード',
        delete: '削除',
        top: 'トップに置く',
        bottom: 'ボトムに置く',
        productName: '商品名',
        operation: '操作',
        placeInputGoodsName: '商品名または商品コードを入力してください',
        placeSearchAdd: '商品を検索して追加してください',
        alreadyInGoodsList: 'すでに商品リストにあります',
        addError: '追加失敗',
        addSuccess: '追加しました、"ドラフトを保存"を忘れずに',
        topSuccess: 'トップに置く完了、"ドラフトを保存"を忘れずに',
        bottomSuccess: 'ボトムに置く完了、"ドラフトを保存"を忘れずに',
        put: '販売開始',
        out: '販売停止',
        sortSuccess: '並べ替え成功、"ドラフトを保存"を忘れずに',
        stockNumTitle: '在庫数'
      },
      form: {
        setting: 'コンポーネント設定',
        location: 'クライアントタイプ',
        systemRecommendNum: '推奨数',
        systemRecommendPlaceHolder: '请输入推荐数量',
        placeSelectLocation: 'クライアントタイプを選択してください',
        contentSetting: '内容設定',
        pcNum: 'PCサイトの1行あたりの表示数',
        oneLineNum: '各行の表示数',
        pcSpacing: 'PCサイトの画像間隔',
        ImageSpacing: '画像の左右余白',
        ImageVerticalSpacing: '画像の上下余白',
        pcDynamic: 'PCサイトのマウスホバー効果',
        Dynamic: 'ホバー時のアニメーション効果（マウスオーバー動作）',
        open: 'オン',
        close: 'オフ',
        pcBannerHeight: 'PCサイトの広告画像高さ',
        BannerHeight: '広告画像の高さ',
        mNum: 'モバイルサイトの1行あたりの表示数',
        mSpacing: 'モバイルサイトの画像間隔',
        mBannerHeight: 'モバイルサイトの広告画像高さ',
        BannerWidth: '广告图宽度',
        mobile: 'モバイルサイト',
        pc: 'PCサイト',
        bgColor: '背景色',
        mobileBgColor: 'モバイル端の背景色',
        pcBgColor: 'PC端の背景色',
        goodsTitle: '商品リストタイトル',
        titleColor: 'タイトル色',
        textSize: 'テキストサイズ',
        goods: '商品',
        banner: '広告画像',
        deleteSuccess: '削除しました,"ドラフトを保存"を忘れずに',
        deleteError: '削除に失敗しました',
        indexTip: 'アンカー名は、プレビュー時に商品リストに基づいて動的に生成されます',
        sticky: '上に吸着',
        is: 'はい',
        no: 'いいえ',
        textColor: 'テキスト色',
        textSelectColor: 'テキスト色を選択してください',
        status: '状態',
        visible: '表示',
        hidden: '非表示',
        textOrIconColor: 'テキスト/アイコン色',
        textOrIconHoverColor: 'テキスト/アイコンマウスホバー色',
        stickyShow: '上に吸着表示',
        onlyPc: 'PCサイトでのみ有効',
        elementSet: 'エレメント設定',
        logoWidth: 'LOGO幅',
        langButton: '多言語ボタン',
        searchButton: '検索ボタン',
        accountButton: '個人アカウントボタン',
        cartButton: 'ショッピングカートボタン',
        paddingTop: 'PCサイトの上マージン',
        paddingBottom: 'PCサイトの下マージン',
        newTip: '内容は【新着情報】のデータを自動的に呼び出します',
        showPublicDate: '公開日を表示',
        newTitle: '新着情報のタイトル',
        newList: '新着情報の内容',
        textOrIconHoverColor2: 'テキストマウスホバー色',
        showBranches: '表示数',
        moreVisible: 'もっと表示しますか',
        moreText: 'ボタンのタイトル',
        moreLink: 'リンクアドレス',
        pcBg: 'PC版の背景色',
        mobileBg: 'モバイル版の背景色',
        pcShowNum: 'PC版の表示件数',
        mobileShowNum: 'モバイル版の表示件数',
        noticeLink: '公告リンク',
        mainTitle: '主タイトル',
        subTitle: 'サブタイトル',
        mainTitle_placeholder: 'メインタイトルを入力してください',
        mainTitle_placeholder2: '【アナウンスメントバー】のメインタイトルを入力してください',
        // 页脚
        content: '内容',
        logoInfo: 'LOGO情報',
        siteLogo: 'ウェブサイトロゴ',
        customLink: 'カスタムリンク',
        placeSelectContent: '内容タイプを選択してください',
        copyrightContent: '著作権内容',
        dividingLineColor: '分割線色',
        copyright: 'ウェブサイトの著作権',
        text: 'テキスト',
        shareMedia: 'ソーシャルメディア',
        mediaIconSize: 'ソーシャルメディアアイコンサイズ',
        dividingColor: 'アンダーライン色',
        addCustomLink: 'カスタムリンクを追加',
        deleteContent: '内容を削除',
        // navbar
        menuCategor: '商品カテゴリー',
        toggle: 'スイッチ',
        showTitle: 'タイトルを表示',
        menulist: 'メニューリスト',
        addMenu: 'メニューを追加',
        menuSpacing: 'メニュー間隔',
        menuItem: '菜メニューアイテム单项',
        customMenu: 'カスタムメニュー',
        // spacing
        pcSpacingHeight: 'PCサイトの間隔高さ',
        mSpacingHeight: 'モバイルサイトの間隔高さ',
        // swiper
        autoPlay: '自動再生',
        interval: '自動再生間隔',
        pcSwiperHeight: 'PCスライドの高さ',
        mSwiperHeight: 'モバイルサイトスライドの高さ',
        mHorizontailPadding: 'モバイルサイトページの左右マージン',
        pcHorizontailPadding: 'PCサイトページの左右マージン',
        icon: 'アイコン',
        iconSize: 'iconサイズ',
        gzhIcon: '公众号图片',
        link: 'リンク',
        vertical: '縦スクロール',
        pdfUpload: 'PDFアップロード',
        pdfUploadSuccessTip: 'ファイルのアップロードに成功しました',
        pdfUploadFailTip: 'ファイルのアップロードに失敗しました。再度アップロードしてください',
        titlePaddingTop: 'タイトルの上余白',
        titlePadingBottom: 'タイトルの下余白',
        PCMedia: 'PC版',
        mediaIconRight: 'ソーシャルメディアアイコンの右余白',
        mediaIconBottom: 'ソーシャルメディアアイコンの下余白',
        mediaIconType: 'アイコンタイプ',
        image: '画像',
        marginSpace: '左右の余白',
        info: '情報',
        subject: '特集',
        subjectTitle: '特集名',
        addProduct: '商品を追加',
        defualtSort: 'デフォルト順',
        onlineSort: '販売開始時間順',
        stockSort: '初回入庫日',
        linkSet: 'リンク設定',
        productSearch: '商品検索結果',
        couponList: '优惠券列表',
        page: 'ページ',
        place: '選択してください',
        channel: '推广平台',
        category: '商品カテゴリー',
        brand: 'ブランド',
        transort: '配達方法',
        sort: '排序',
        orderType: 'ソートタイプ',
        orderWay: '排序方式',
        placeOfOrigin: '原産地',
        placeInput: '入力してください',
        pageCode: '页码',
        sale: '销量',
        price: '价格',
        commont: '评价',
        newProduct: '新品',
        sort_up: '升序',
        sort_down: '降序',
        bundleCheck: '使用同捆',
        keyword: 'キーワード',
        exactMatch: '精确匹配',
        dimMatch: '模糊匹配',
        matchtype: '匹配方式',
        activeDetail: 'キャンペン詳細',
        activity: 'キャンペーン情報',
        categoryTitle: "タイトル",
        pdfPage: 'PDFページ'
      }
    }
  }
};